@if(this.dataService.operation.value){
    <div id="content_footer">&#169; {{this.dataService.operation.value.pwa?.name}} - {{this.currentYear}}</div>
}